import { createContext, Context } from 'react';
import { ScreenController } from 'components/screen/screen.controller';

export const ScreenContext: Context<ScreenController> = createContext<ScreenController>(new ScreenController());